
import {
    inBrowser,
    decodeUserToken,
} from "../helpers/omniElements"

function useUserInfo() {
    const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
    let userInfo = {}
    if (accessToken) {
        userInfo = decodeUserToken(accessToken)
    }
    return userInfo
}

export default useUserInfo